/**
 * @typedef {"abandon"|"continueToPaymentErrors"|"storeForLater"|"retry"|"viewOrder"} OrderErrorModalAction
 */

/**
 * @typedef {"abandon"|"retry"|"viewOrder"} PaymentErrorModalAction
 */

/**
 * The two typedefs above are comprised of these values.
 * Those are useful to use in jsdocs, as we can't use CheckoutErrorActions as a value.
 */
const CheckoutErrorActions = {
    // Give up on the order after the errors.
    // Leave it unsaved, and throw the cart away.
    ABANDON: 'abandon',

    // If there are both order and payment errors,
    // continue from the order error modal to the payment error modal.
    CONTINUE_TO_PAYMENT_ERRORS: 'continueToPaymentErrors',

    // If this was an order error due to connection issues,
    // store the order in the queue to submit later.
    STORE_FOR_LATER: 'storeForLater',

    // Try to submit the order again immediately.
    RETRY: 'retry',

    // View the order details, even if there were errors.
    // This is for orders that were successfully created but had errors after being saved.
    VIEW_ORDER: 'viewOrder',
};

module.exports = CheckoutErrorActions;
